import { render, staticRenderFns } from "./CartItemsGroup.vue?vue&type=template&id=770c66c9&scoped=true&"
import script from "./CartItemsGroup.vue?vue&type=script&lang=js&"
export * from "./CartItemsGroup.vue?vue&type=script&lang=js&"
import style0 from "./CartItemsGroup.vue?vue&type=style&index=0&id=770c66c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c66c9",
  null
  
)

export default component.exports